import PropTypes from 'prop-types';
import { memo, useState, useLayoutEffect, useRef } from 'react';
import PrimaryPanelHeader from './Header';
import PrimaryPanelInformation from './Information';

const PrimaryPanel = memo(({ model, openSecondary }) => {
    const headerRef = useRef(null);
    const [descriptionOffsetHeight, setDescriptionOffsetHeight] = useState(0);

    useLayoutEffect(() => {
        if (!headerRef.current) return;
        const observer = new ResizeObserver(([entry]) => {
            setDescriptionOffsetHeight(entry.contentRect.height);
        });
        observer.observe(headerRef.current);
        return () => observer.disconnect();
    }, []);

    return (
        <div className="panel-primary">
            <PrimaryPanelHeader
                model={model}
                openSecondary={openSecondary}
                containerReference={headerRef}
            />
            <PrimaryPanelInformation
                model={model}
                calculatedOffsetHeight={descriptionOffsetHeight}
            />
        </div>
    );
});

PrimaryPanel.propTypes = {
    model: PropTypes.object.isRequired,
    openSecondary: PropTypes.func,
};

export default PrimaryPanel;
